import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSiteMode, resetSiteMode } from '../Store/settings/siteSettings';
import StudentAnswer from '../components/studentDashboard/StudentAnswers';
import ArrowLeftBrown from '../assets/images/arrow-left-brown.svg';
import ArrowRightBrown from '../assets/images/arrow-right-brown.svg';
import { StudentHeader } from '../components/StudentHeader';
import close from '../assets/images/model/close.svg';
import StudentGradSidebar from '../components/studentDashboard/StudentGradSidebar';
import { useNavigate, useParams } from 'react-router-dom';
import {
  activityAnswer,
  activityById,
  activityInProgress,
  studentClassSection,
} from '../Store/api/activities';
import { forStudent } from '../Store/api/activities';

import ImageVideoViewer from '../components/mediaView/ImageVideoViewer';
import { getBook } from '../Store/api/student';
import { updateActivityAnswer } from '../Store/entities/student';
import SidebarMinmized from '../components/SidebarMinmized';
import { toast } from 'react-toastify';
import moment from 'moment';
import MediaComponent from '../components/activity/MediaComponent';
function stripHtmlTags(htmlString) {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
}
export const StudentFocusedMode = ({}) => {
  const navigate = useNavigate();
  const { studentActivityLoader } = useSelector((state) => state.ui.loaders);
  const { id } = useParams();
  const [complteDueNext, setComplteDueNext] = useState(false);
  const [isBookExpanded, setIsBookExpanded] = useState(false);
  const [tabConent, setTabs] = useState('book');
  const [activity, setActivity] = useState({
    questions: [],
    assignedDate: '',
    activityAnswers: [],
    isSubmitted: false,
  });
  const [activityAnswers, setActivityAnswers] = useState([]);
  const [isErrored, setIsErrored] = useState(false);

  const [loading, setLoading] = useState(false);
  const [activityLoading, setActivityLoading] = useState(false);
  const [opendate, setOpenedDate] = useState('');
  const [isSubmitted, setIsSubmitted] = useState('');
  const [sectionId, setSectionId] = useState('');
  const [editorValue, setEditorValue] = useState('');
  const [bookClasses, setBookClasses] = useState([]);
  const [updateAnswers, setUpdateAnswers] = useState([]);
  const [maximizeImage, setMaximizeImage] = useState(false);
  const [imageVideoUrl, setImageVideoUrl] = useState();
  const [studentAnswers, setStudentAnswers] = useState([]);
  const [shouldFetchActivity, setShouldFetchActivity] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [dropDownActions, setDropDownActions] = useState(null);
  const [modelSuccessUrl, setModelSuccessUrl] = useState('');
  const [canLeave, setCanLeave] = useState(true);
  const [reCenter, setReCenter] = useState(false);
  const dispatch = useDispatch();

  /* The below code about for right side bar submited and complete activities */
  const { activitiesByAssignedDate } = useSelector((state) => state.entities.student.book);
  const today = new Date().setHours(0, 0, 0, 0);
  const { next, prev } = useMemo(() => {
    let next, prev;
    let index = -1;
    const list = [];

    for (const { activities } of activitiesByAssignedDate.filter((e) =>
      e.activities.some((a) => a._id === id)
    )) {
      for (const activity of activities) {
        // if (!activity?.assignedDate || new Date(activity?.assignedDate) <= today)
        //   continue;

        list.push(activity._id);

        if (index >= 0) break;
        if (activity._id === id) index = list.length - 1;
      }
    }

    next = list?.[index + 1];
    prev = list?.[index - 1];

    return { next, prev };
  }, [id, activitiesByAssignedDate]);

  /* ...................................... */

  /* For Date format */
  const assignedDate = new Date(activity?.assignedDate);
  assignedDate.setHours(0, 0, 0, 0);
  const month = (assignedDate.getMonth() + 1).toString().padStart(1, '0');
  const day = assignedDate.getDate().toString().padStart(2, '0');
  const year = assignedDate.getFullYear().toString().slice(-2);
  const formattedDate = `${month}.${day}.${year}`;
  /* End........... */

  const handleLastActivity = () => {
    if (!canLeave) {
      setIsShowModal(true);
      if (prev) {
        setModelSuccessUrl(`/studentfocusedmode/${prev}`);
      } else {
        setModelSuccessUrl(-1);
      }
    } else {
      if (prev) navigate(`/studentfocusedmode/${prev}`);
    }

    return;
  };
  const handleNextActivity = (canLeaveFlag = false) => {
    if (!canLeave && !canLeaveFlag) {
      setIsShowModal(true);
      if (next) {
        setModelSuccessUrl(`/studentfocusedmode/${next}`);
      } else {
        setModelSuccessUrl(-1);
      }
    } else {
      if (next) navigate(`/studentfocusedmode/${next}`);
    }

    return;
  };

  /* For Validaation fill in the blanks */

  const questionBlanksLength =
    activity?.questions?.reduce((total, question) => {
      return total + (question.blanksBank?.length || 0); // Sum lengths of all blanksBank arrays
    }, 0) || 0; // Default to 0 if no questions exist

  const getAnswerData = (questions, answers) => {
    let totalBlanksLength = 0;
    let allAnswersNotEmpty = true;

    questions.forEach((question, questionIndex) => {
      const correspondingAnswers = answers.find((answer) => answer.questionId === question._id);

      if (question.blanksBank?.length > 0) {
        const studentSelectedBlanks = correspondingAnswers?.studentSelectedBlanks || [];

        // Check if all blanks are answered
        if (!studentSelectedBlanks.every((blank) => blank.answers && blank.answers[0] !== '')) {
          allAnswersNotEmpty = false; // Mark as false if any blank is unanswered
        }

        totalBlanksLength += studentSelectedBlanks.length;
      }
    });

    return { totalBlanksLength, allAnswersNotEmpty };
  };

  const { totalBlanksLength, allAnswersNotEmpty } = getAnswerData(
    activity?.questions || [],
    activityAnswers
  );
  const isSubmitDisabled = questionBlanksLength !== totalBlanksLength && allAnswersNotEmpty;
  const typeblanks =
    activityAnswers?.length > 0 && activityAnswers?.some((ans) => ans.type === 'blanks');

  /* ................... */

  /* For Done Button. This code will called when all answer is correct and graded */
  function calculatePercentage(activityAnswers) {
    if (
      !activityAnswers ||
      !Array.isArray(activityAnswers) ||
      activityAnswers.length === 0 ||
      !activityAnswers[0].answers
    ) {
      return 0;
    }

    let totalCorrect = 0;
    const totalAnswers = activityAnswers[0]?.answers?.length;

    activityAnswers[0].answers.forEach((answer) => {
      if (answer.isCorrect) {
        totalCorrect++;
      }
    });

    const percentage = (totalCorrect / totalAnswers) * 100;
    return percentage;
  }

  const percentage = calculatePercentage(activity?.activityAnswers);
  /* ................. */

  /* .............. */
  const currentDate = new Date().setHours(0, 0, 0, 0);
  const submittedActivities = activitiesByAssignedDate.filter((e) => {
    const assingedDate = new Date(e.assignedDate);
    assingedDate.setHours(0, 0, 0, 0);
    return (
      (e?.answers?.length > 0 &&
        assingedDate.getTime() < currentDate &&
        e?.answers?.length &&
        !e.answers.filter((e) => e?.isGraded).length) ||
      (e?.answers?.length > 0 &&
        assingedDate.getTime() > currentDate &&
        e?.answers?.length &&
        !e?.answers?.filter((e) => e?.isGraded).length)
    );
  });

  useEffect(() => {
    const storedUserId = localStorage.getItem('sectionId');
    if (storedUserId) {
      setSectionId(storedUserId);
    }
  }, []);
  useEffect(() => {
    dispatch(setSiteMode('teach'));
    return () => {
      dispatch(resetSiteMode());
    };
  }, []);

  useEffect(() => {
    let hasError = false;

    for (let index = 0; index < activityAnswers?.length; index++) {
      const answer = activityAnswers[index];
      // Handle "mcqs" and "truefalse" types
      if (answer.type === 'mcqs' || answer.type === 'truefalse') {
        if (
          answer.answerIndex === -1
          // || new Date(activity?.assignedDate) < new Date().setHours(0, 0, 0, 0)
        ) {
          hasError = true;
          break;
        }
      }
      // Handle "fr" and "sa" types
      else if (answer.type === 'fr' || answer.type === 'sa') {
        if (
          !answer.answerText ||
          stripHtmlTags(answer.answerText) === ''
          // || new Date(activity?.assignedDate) < new Date().setHours(0, 0, 0, 0)
        ) {
          hasError = true;
          break;
        }
      } else if (answer.type === 'blanks' && !isSubmitDisabled) {
        hasError = true;
        break;
      }
    }

    // Update the error state based on the validation
    setIsErrored(hasError);
  }, [activityAnswers, activity?.assignedDate]); // Make sure to add any relevant dependencies

  useEffect(() => {
    const openedDate = localStorage.getItem('openedDate');
    if (openedDate) {
      // setComplteDueNext(true);
      setOpenedDate(openedDate);
    }
  }, []);

  const blankOption = () => {
    return <div className='blanks-field'></div>;
  };

  /* Activity Attempt Multipe Time */
  const AttemptMultiple = (attemptClasses) => {
    if (attemptClasses.length > 0) {
      const activitySettings = attemptClasses[0]?.classes?.activitySettings;
      const multipleAttempts = activitySettings?.multipleAttempts;
      const count = multipleAttempts?.count ?? '0'; // Access the count
      const isAllowed = multipleAttempts?.isAllowed ?? false; // Access isAllowed
      return { count, isAllowed };
    } else {
      return { count: '0', isAllowed: false }; // Default values if no data
    }
  };

  // Assuming bookClasses is the input to AttemptMultiple
  const result = AttemptMultiple(bookClasses);
  const { count, isAllowed } = result;

  const [submissionCount, setSubmissionCount] = useState(0); // Start from 0 for the first submission

  // Function to determine if the user can submit (check if submission count is less than allowed)
  const canSubmit = submissionCount < count && isAllowed;

  useEffect(() => {
    setActivityLoading(true);
    dispatch(
      activityById({
        id: id,
        onSuccess: (res) => {
          const activityData = res?.data?.data?.[0] || {};

          if (Object.keys(activityData).length) {
            setActivity(activityData);
            const processedAnswers = activityData?.questions?.map((e, index) => {
              const ansObj = {
                question: e._id,
                type: e.type,
              };

              if (e.type === 'mcqs' || e.type === 'truefalse') {
                ansObj.answerIndex = activityData.activityAnswers[0].answers.length
                  ? activityData.activityAnswers[0].answers[index].answerIndex
                  : -1;
              } else if (e.type === 'fr' || e.type === 'sa') {
                ansObj.answerText = activityData.activityAnswers[0].answers.length
                  ? activityData.activityAnswers[0].answers[index].answerText
                  : '';
              } else if (e.type === 'blanks') {
                ansObj.answerText = activityData.activityAnswers[0].answers.length
                  ? activityData.activityAnswers[0].answers[index].answerText
                  : '';

                ansObj.answerText = e.bankQuestion;
                ansObj.answerArray = e.bankQuestion;
                ansObj.answerArray = e.bankQuestion.map((text, ind) =>
                  e.blanksBank.some((e) => e.indexNo === ind)
                    ? !activityData.activityAnswers[0].isSubmitted
                      ? ''
                      : activityData.activityAnswers[0].answers[index].studentSelectedBanks.find(
                          (e) => e.indexNo === ind
                        ).answers[0]
                    : text
                );
                ansObj.studentSelectedBlanks = activityData.activityAnswers[0].answers.length
                  ? activityData.activityAnswers[0].answers[index].studentSelectedBanks
                  : e.blanksBank.map((blank) => ({
                      indexNo: blank.indexNo,
                      answers: [],
                    }));
              }

              return ansObj;
            });

            setActivityAnswers(processedAnswers);
          }
          setActivityLoading(false);
        },
        onError: (err) => {
          setActivityLoading(false);
          // Handle error here
        },
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(
      forStudent({
        onSuccess: (res) => {},
        onError: (err) => {},
      })
    );
  }, []);

  const setAnswer = (index, name, value) => {
    setActivityAnswers((old) =>
      old.map((e, oldIndex) => (index === oldIndex ? { ...e, [name]: value } : e))
    );
  };

  const completedActivities = (act) => {
    if (act?.activityAnswers && act?.activityAnswers.length > 0) {
      // Check if every activityAnswer in activityAnswers is graded and has answers
      return act?.activityAnswers.every(
        (activityAnswer) => activityAnswer.isGraded && activityAnswer.grade === 100
      );
    }
    return false;
  };

  const completedActivity = completedActivities(activity);

  const handleActivityProgress = () => {
    const activityAnswerId = activity?.activityAnswers?.[0]?._id;
    if (!activityAnswers || !activityAnswerId) {
      console.error('Missing required data: answers or activityAnswer ID.');
      return;
    }

    dispatch(
      activityInProgress({
        body: {
          answers: activityAnswers,
          activityAnswer: activityAnswerId,
        },
        onSuccess: (res) => {
          setShouldFetchActivity(true);
          dispatch(
            updateActivityAnswer({
              id: activity?._id,
              date: activity?.assignedDate,
              answer: res.data.data,
            })
          );
        },
        onError: (err) => {},
      })
    );
  };

  /* For Fill in the Blanks and Free Response */
  useEffect(() => {
    // Check if any activityAnswer has a type of "fr" or "blanks"
    const hasRelevantType = activityAnswers?.some((answer) =>
      ['fr', 'sa', 'blanks'].includes(answer.type)
    );

    if (hasRelevantType) {
    }
  }, [activityAnswers]);

  /* ////////////// */
  useEffect(() => {
    dispatch(
      studentClassSection({
        onSuccess: (res) => {
          const data = res?.data?.data || [];
          if (data?.length > 0) {
            setBookClasses(data);
          } else {
            console.error('No class section data found.');
          }
        },
        onError: (err) => {
          console.error('Error fetching student class section:', err);
        },
      })
    );
  }, [dispatch]);
  /* ................. */
  useEffect(() => {
    let canLeave = true;
    if (!activity?.activityAnswers?.[0]?.isSubmitted && activityAnswers?.length) {
      for (let index = 0; index < activityAnswers.length; index++) {
        const answer = activityAnswers[index];
        const ques = activity.questions[index];
        switch (ques.type) {
          case 'mcqs':
            if (answer.answerIndex > -1) {
              canLeave = false;
              break;
            }
            break;
          case 'truefalse':
            if (answer.answerIndex > -1) {
              canLeave = false;
              break;
            }
            break;
          case 'blanks':
            if (
              answer.studentSelectedBlanks.length > 0 &&
              answer.studentSelectedBlanks.some((e) => e.answers.length > 0)
            ) {
              canLeave = false;
              break;
            }
            break;
          case 'fr':
            if (answer.answerText !== '') {
              canLeave = false;
              break;
            }
            break;
          case 'sa':
            if (answer.answerText !== '') {
              canLeave = false;
              break;
            }
            break;
          default:
            break;
        }
      }
    }
    setCanLeave(canLeave);
  }, [activityAnswers, activity]);

  // Flatten to get a single array if needed
  const checkAndHandleProgress = () => {
    if (activity?.activityAnswers?.[0]?.isSubmitted) return;
    let canBeInProgress = false;
    for (let index = 0; index < activityAnswers.length; index++) {
      const answer = activityAnswers[index];
      switch (answer.type) {
        case 'fr':
          if (answer.answerText) {
            canBeInProgress = true;
            break;
          }
          break;
        case 'sa':
          if (answer.answerText) {
            canBeInProgress = true;
            break;
          }
          break;
        case 'mcqs':
          if (answer.answerIndex > -1) {
            canBeInProgress = true;
            break;
          }
          break;

        case 'truefalse':
          if (answer.answerIndex > -1) {
            canBeInProgress = true;
            break;
          }
          break;
        case 'blanks':
          if (
            Array.isArray(answer.studentSelectedBlanks) &&
            answer.studentSelectedBlanks.some((e) => e.answers.length > 0)
          ) {
            canBeInProgress = true;
            break;
          }
          break;

        default:
          break;
      }
    }
    if (canBeInProgress) {
      handleActivityProgress();
    }
  };
  const handleBlanks = (blankValue, questionIndex) => {
    setActivityAnswers((old) =>
      old.map((ans, i) =>
        i === questionIndex
          ? {
              ...ans,
              studentSelectedBlanks: ans.studentSelectedBlanks.map((stdA, i) =>
                stdA.indexNo === blankValue.indexNo
                  ? { ...stdA, answers: blankValue.answers }
                  : stdA
              ),
              answerArray: ans.answerArray.map((text, i) =>
                i !== blankValue.indexNo ? text : blankValue.answers[0]
              ),
            }
          : ans
      )
    );
  };

  return (
    <div className='grading_wrapper cursor_default '>
      <div
        className={`left_side_bar_grade_mode ${isBookExpanded ? '' : 'expanded'}`}
        style={{ overflowY: 'clip' }}
      >
        <StudentGradSidebar
          setIsBookExpanded={setIsBookExpanded}
          complteDueNext={complteDueNext}
          tabConent={tabConent}
          setTabs={setTabs}
          bookId={activity?.book}
          activity={activity}
          reCenter={reCenter}
        />
      </div>
      <div className={`center_box ${isBookExpanded ? '' : 'minimized'}`}>
        <StudentHeader
          style={{ padding: '0 0 0 16px' }}
          searchBarWidth={tabConent === 'book' ? '45.7%' : '56%'}
          dropdownWidth={tabConent === 'book' ? '52%' : '42%'}
          isSubmitted={isSubmitted}
          canLeave={canLeave}
          setIsShowModal={setIsShowModal}
          setDropDownActions={setDropDownActions}
          setModelSuccessUrl={setModelSuccessUrl}
        />
        <div className='grading_box' style={{ height: 'calc(100vh - 70px)' }}>
          <div
            className={`gradding_main gradding_main_student ${
              isBookExpanded ? 'gradding_student_expend' : 'minimized'
            }`}
            style={{ paddingLeft: '40px' }}
          >
            {maximizeImage ? (
              <div className='preview-before'>
                <ImageVideoViewer
                  setMaximizeImage={setMaximizeImage}
                  imageVideoUrl={imageVideoUrl}
                />
              </div>
            ) : (
              <div className='preview-after'>
                <div
                  className='gradding_progressbar-std progress-top-botton'
                  style={{ minHeight: '6px' }}
                >
                  {(isBookExpanded || !isBookExpanded) &&
                  (percentage === 100 || completedActivity) ? (
                    <Fragment></Fragment>
                  ) : (
                    <Fragment>
                      {activityAnswers?.map((answer, index) => (
                        <div
                          key={index}
                          className={`bar_1 ${
                            ((answer.type === 'mcqs' || answer.type === 'truefalse') &&
                              answer.answerIndex === -1) ||
                            ((answer.type === 'fr' || answer.type === 'sa') &&
                              stripHtmlTags(answer.answerText || '') === '') ||
                            (answer.type === 'blanks' && !isSubmitDisabled)
                              ? 'to_start to-background'
                              : 'active_bar to_end'
                          }`}
                          style={{ width: '100%' }}
                        ></div>
                      ))}
                    </Fragment>
                  )}
                </div>
                <div className='gradding_activity_box cursor_default'>
                  <div className='gradding_top'>
                    <div className='d-flex justify-content-between'>
                      <h3>{activity?.graded}-graded</h3>
                      {moment(activity?.assignedDate).isBefore(
                        moment(activity.activityAnswers?.[0]?.submittedAt),
                        'D'
                      ) && (
                        <h3
                          style={{
                            color: '#AE2604',
                          }}
                        >
                          {' '}
                          {activity.activityAnswers?.[0]?.penaltyCalculated || 0}% late penalty
                        </h3>
                      )}
                      <div className='d-flex justify-content-between gap-1'>
                        {activity?.activityAnswers?.[0]?.isSubmitted && (
                          <h3
                            style={{
                              ...(moment(activity?.assignedDate).isBefore(
                                moment(activity.activityAnswers?.[0].submittedAt),
                                'D'
                              ) && { color: '#AE2604' }),
                            }}
                          >
                            submitted{' '}
                            {moment(activity?.activityAnswers?.[0]?.submittedAt).format('M.DD.YY')}
                          </h3>
                        )}
                        <h3>Due {activity?.assignedDate == null ? null : formattedDate}</h3>
                      </div>
                    </div>
                    <div
                      className='d-flex justify-content-between cursor'
                      onClick={() => {
                        setReCenter(true);
                        setTimeout(() => {
                          setReCenter(false);
                        }, 500);
                      }}
                    >
                      <h4 className='v_more' style={{ color: 'var(--Amber-800, #AD6302)' }}>
                        <u>
                          chapter {activity?.chap && activity?.chap[0]?.order}
                          {activity?.sec && (
                            <>
                              , section {activity?.sec?.order}
                              {activity?.chap && activity?.chap[0]?.sections}
                            </>
                          )}
                        </u>
                      </h4>
                      {/* <h4 className="v_more">student name</h4> */}
                    </div>
                  </div>
                  <div className='answer_title_box'>
                    <h2>{activity?.title}</h2>
                    <p className='pts'>
                      <b>{activity?.score ? activity?.score : ' '}</b> pts |{' '}
                      {activity?.questions?.length} questions
                    </p>
                  </div>
                  <div className='spread-activity-description' style={{ marginBottom: '12px' }}>
                    {activity?.description}
                  </div>
                  {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
                    <div style={{ width: '95%' }}>
                      {['text', 'image', 'video', 'audio'].includes(
                        activity?.activityInstructionsType
                      ) && (
                        <MediaComponent
                          media={{
                            url: activity?.activityInstructionUrl || '',
                            type: activity?.activityInstructionsType || 'text',
                          }}
                          mode='student'
                          setMaximizeImage={setMaximizeImage}
                          setImageVideoUrl={setImageVideoUrl}
                        />
                      )}
                    </div>
                  </div> */}

                  {/* {answers.map((answer, index) => ( */}
                  {activityLoading || studentActivityLoader ? (
                    <div>loading...</div>
                  ) : (
                    <StudentAnswer
                      activity={activity}
                      answers={activityAnswers}
                      setAnswer={setAnswer}
                      setUpdateAnswers={setUpdateAnswers}
                      submittedActivities={submittedActivities}
                      percentage={percentage}
                      editorValue={editorValue}
                      answerArrayNotEmpty={allAnswersNotEmpty}
                      completedActivity={completedActivity}
                      handleActivityProgress={handleActivityProgress}
                      shouldFetchActivity={shouldFetchActivity}
                      setMaximizeImage={setMaximizeImage}
                      setImageVideoUrl={setImageVideoUrl}
                      setStudentAnswers={setStudentAnswers}
                      handleBlanks={handleBlanks}
                      studentAnswers={studentAnswers}
                    />
                  )}
                </div>

                <div className='gradding_bottom_navigation'>
                  <div className='navigation_wrapper' style={{ justifyContent: 'flex-end' }}>
                    <div className='submit-button'>
                      <button
                        className={`navigational_buttons border-color ${
                          !prev && 'disabled-button'
                        }`}
                        onClick={() => {
                          checkAndHandleProgress();
                          handleLastActivity();
                          // setTimeout(() => {
                          //   setStudentAnswers([]);
                          // }, 600);
                        }}
                        disabled={!prev}
                      >
                        <img
                          src={ArrowLeftBrown}
                          alt='next'
                          style={{
                            marginRight: '10px',
                          }}
                        />
                        Last Activity
                      </button>

                      <button
                        className={`navigational_buttons border-color ${
                          !next && 'disabled-button'
                        }`}
                        onClick={() => {
                          checkAndHandleProgress();
                          handleNextActivity();
                          // setTimeout(() => {
                          //   setStudentAnswers([]);
                          // }, 600);
                        }}
                        disabled={!next}
                      >
                        Next Activity
                        <img src={ArrowRightBrown} alt='pre' style={{ marginLeft: '10px' }} />{' '}
                      </button>
                      {activity?.activityAnswers?.[0]?.isGraded &&
                      (activity?.activityAnswers[0].grade === 100 ||
                        (activity?.activityAnswers[0].grade < 100 &&
                          new Date(activity?.assignedDate).setHours(0, 0, 0, 0) <
                            new Date().setHours(0, 0, 0, 0))) ? (
                        <button
                          className='navigational_buttons activity_submit'
                          onClick={() => {
                            localStorage.setItem(
                              'openedDate',
                              new Date(activity?.assignedDate).setHours(0, 0, 0, 0)
                            );
                            localStorage.setItem('activityId', activity._id);

                            if (next) {
                              handleNextActivity();
                            } else {
                              navigate(
                                -1 *
                                  activitiesByAssignedDate?.find(
                                    (e) =>
                                      new Date(e.assignedDate).setHours(0, 0, 0, 0) ===
                                      new Date(activity?.assignedDate).setHours(0, 0, 0, 0)
                                  )?.activities?.length
                              );
                            }
                          }}
                        >
                          Done
                        </button>
                      ) : (
                        <button
                          className='navigational_buttons activity_submit'
                          onClick={() => {
                            setLoading(true);
                            setCanLeave(true);

                            dispatch(
                              activityAnswer({
                                body: {
                                  answers: activityAnswers,
                                  activityAnswer: activity?.activityAnswers?.[0]?._id,
                                },
                                onSuccess: (res) => {
                                  setEditorValue(res.data.data);
                                  dispatch(
                                    updateActivityAnswer({
                                      id: activity._id,
                                      date: activity?.assignedDate,

                                      answer: res.data.data,
                                    })
                                  );
                                  // Increment submission count on success
                                  setSubmissionCount((prevCount) => prevCount + 1);
                                  setIsSubmitted(res.data.data.isSubmitted);

                                  localStorage.setItem(
                                    'openedDate',
                                    new Date(activity?.assignedDate).setHours(0, 0, 0, 0)
                                  );
                                  localStorage.setItem('activityId', activity._id);
                                  localStorage.setItem('activityIndex', activity._id);

                                  if (next) {
                                    handleNextActivity(true);
                                  } else {
                                    navigate(
                                      -1 *
                                        activitiesByAssignedDate?.find(
                                          (e) =>
                                            new Date(e.assignedDate).setHours(0, 0, 0, 0) ===
                                            new Date(activity?.assignedDate).setHours(0, 0, 0, 0)
                                        )?.activities?.length
                                    );
                                  }

                                  setLoading(false);
                                },
                                onError: (err) => {
                                  toast.error(
                                    err?.response?.data?.message ||
                                      'Could not submit at the moment'
                                  );
                                  setLoading(false);
                                },
                              })
                            );
                          }}
                          disabled={isErrored || loading || (typeblanks && !isSubmitDisabled)}
                        >
                          {loading ? 'Submitting...' : 'Submit'}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <SidebarMinmized
            setComplteDueNext={setComplteDueNext}
            setIsShowModal={setIsShowModal}
            canLeave={canLeave}
            setModelSuccessUrl={setModelSuccessUrl}
            id={id}
            complteDueNext={complteDueNext}
            setIsBookExpanded={setIsBookExpanded}
            activitiesByAssignedDate={activitiesByAssignedDate}
            oepnedDate={opendate}
            tabConent={tabConent}
            setTabs={setTabs}
            activity={activity}
            setOpenedDate={setOpenedDate}
            setShouldFetchActivity={setShouldFetchActivity}
            shouldFetchActivity={shouldFetchActivity}
            checkAndHandleProgress={checkAndHandleProgress}
            isBookExpanded={isBookExpanded}
          />
        </div>
      </div>
      {isShowModal && (
        <div
          className='modal custom_background custom_modal_create'
          id='upload_book'
          style={{ display: 'block' }}
          tabIndex='-1'
          aria-labelledby='upload_bookLabel'
          aria-hidden='true'
        >
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header'>
                <button
                  type='button'
                  className='btn-close'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <img
                    src={close}
                    alt='close'
                    onClick={() => {
                      setIsShowModal(false);
                      setModelSuccessUrl('');
                    }}
                  />
                </button>
              </div>
              <div className='modal-body-cre'>
                <h4>don’t forget to submit</h4>
                <p>
                  You started some activities but did not submit them. Are you sure you want to
                  continue to leave?
                </p>

                <div className='modal-btn'>
                  <button
                    type='button'
                    className='btn-black_create mb-24'
                    onClick={() => {
                      if (dropDownActions) {
                        if (dropDownActions.bookId) {
                          dispatch(
                            getBook({
                              id: dropDownActions.bookId, // Use the book ID from the item
                              onSuccess: (res) => {},
                              onError: (err) => {},
                            })
                          );
                        }
                        localStorage.setItem('sectionId', dropDownActions.sectionId);
                        setDropDownActions(null);
                      }
                      navigate(modelSuccessUrl);
                      setModelSuccessUrl('');
                      setIsShowModal(false);
                    }}
                  >
                    Continue without submitting
                  </button>
                  <button
                    type='button'
                    className='btn-white-create'
                    onClick={() => {
                      setIsShowModal(false);
                      setModelSuccessUrl('');
                    }}
                  >
                    Go back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
